import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import * as ElIcons from '@element-plus/icons-vue'
import App from './App.vue'
import router from './router'
import './css/style.less'
import * as util from '@/libs/util';
import {isNotNull, isNull, msg, msgs, msgh} from '@/libs/util';

const app = createApp(App)

// 注册所有 Element Plus 图标
for (const [key, component] of Object.entries(ElIcons)) {
    app.component(key, component)
}

app.use(ElementPlus, { locale: zhCn })
app.use(router)

app.config.globalProperties.$util = util;
app.config.globalProperties.$isNull = isNull;
app.config.globalProperties.$isNotNull = isNotNull;
app.config.globalProperties.$msg = msg;
app.config.globalProperties.$msgs = msgs;
app.config.globalProperties.$msgh = msgh;

app.mount('#app')
